import PropTypes from 'prop-types'

export const FormSelect = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  required = false,
  disabled = false,
  error,
  helperText,
  children,
}) => (
  <div>
    {label && (
      <label htmlFor={id} className="block text-sm font-medium text-gray-400 mb-2">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
    )}
    <select
      id={id}
      name={name || id}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      required={required}
      disabled={disabled}
      className={`form-input ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-400' : ''}`}
      aria-invalid={error ? 'true' : 'false'}
      aria-describedby={error ? `${id}-error` : helperText ? `${id}-help` : undefined}
    >
      {children}
    </select>
    {error && (
      <p id={`${id}-error`} className="mt-1 text-sm text-red-400">
        {error}
      </p>
    )}
    {helperText && !error && (
      <p id={`${id}-help`} className="mt-1 text-sm text-gray-500">
        {helperText}
      </p>
    )}
  </div>
)

FormSelect.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default FormSelect
